/**
 * Navigation helpers.
 *
 * `isSafeInternalPath` guards `backTo` query-param consumers (EventDetail,
 * CampaignDetail, SequenceDetail, FlightDetail) against open-redirect tricks
 * where a crafted `?backTo=javascript:alert(1)` or `?backTo=//evil.com`
 * would be passed directly to `navigate()`. React Router blocks most cases
 * implicitly, but a few edge cases slip through (e.g. protocol-relative
 * paths render as same-origin in some configurations). Validate explicitly.
 */

export function isSafeInternalPath(
  value: string | null | undefined,
): value is string {
  if (!value) {
    return false;
  }

  // Must start with a single forward slash. Rejects "javascript:..."
  // (no leading slash) and "http://..." (scheme before slash).
  if (!value.startsWith("/")) {
    return false;
  }

  // Reject protocol-relative URLs like "//evil.com/x" which browsers and
  // some history APIs interpret as cross-origin.
  if (value.startsWith("//")) {
    return false;
  }

  // Defense in depth: even after the leading-slash check, reject any
  // embedded scheme markers in the first path segment to catch
  // hand-crafted oddities like "/\\evil.com" or "/javascript:x" that some
  // routers may normalize unexpectedly.
  if (/^\/+[a-z][a-z0-9+.-]*:/i.test(value)) {
    return false;
  }

  return true;
}
